/** @jsx jsx */
import { jsx, useThemeUI } from "theme-ui";
import { Fragment, useEffect } from "react";
import { UAnchorLink } from "../../../components/UAnchorLink";
import { Box, Flex, Heading, Text } from "rebass";
import Hero from "../../../components/Hero";
import ProjectTitleListing from "../../../components/ProjectTitleListing";
import ProjectFadeInTitle from "../../../components/ProjectFadeInTitle";
import BackToTop from "../../../components/BackToTop";
import { StaticImage } from "gatsby-plugin-image";
import BookScene from "../../../components/BookScene";
//import { Modal } from "../../../components/Modal";
//import { useModal } from "../../../components/useModal";
//import Carousel from "../../../components/Carousel";
//import Close from "../../../icons/Close";
import CompanyProjects from "../../../components/CompanyProjects";
import Layout from "../../../layouts/";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import ThemeColorSetter from "../../../components/ThemeColorSetter";

//Assets
//import img1 from "../../../img/bose/b-card-definition-and-anatomy.jpg";
//import img2 from "../../../img/bose/b-card-mobile first.jpg";
//import img3 from "../../../img/bose/b-card-eyebrow-label.jpg";
//import img4 from "../../../img/bose/b-card-action-labels.jpg";
//import img5 from "../../../img/bose/b-card-visual-hierachy.jpg";

//import SourceOfTruth from "../../../icons/SourceOfTruth";

//Videos
import HowToExpressive from "../../../img/ing/how-to-expressive.mp4";
import Expressive from "../../../img/ing/expressive.mp4";
import ExpressiveEngine from "../../../img/ing/expressive-engine.mp4";

function ProjectINGDS() {
  const context = useThemeUI();
  const { theme } = context;
  {
    /* const modalPersona = useModal(); */
  }
  
  //const modalMobileFirst = useModal();

  let pathname = typeof window !== "undefined" ? window.location.pathname : "";
  const section1 = pathname + "#section1";
  const section2 = pathname + "#section2";
  const section3 = pathname + "#section3";
  const section4 = pathname + "#section4";

  const projectBgColor = theme?.colors?.ingProjectBgDs as string;
  const projectTextColor = theme?.colors?.ingProjectTextDs as string;
  const themeColor = theme?.colors?.ingProjectBgDs as string;
  const themeColorBg = theme?.colors?.background as string;

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.getElementById("hero-section");
      if (heroSection) {
        const rect = heroSection.getBoundingClientRect();
        if (rect.bottom > 0) {
          document.body.classList.add("hero-visible");
          document.body.classList.remove("hero-hidden");
        } else {
          document.body.classList.add("hero-hidden");
          document.body.classList.remove("hero-visible");
        }
      } else {
        document.body.classList.add("hero-hidden");
        document.body.classList.remove("hero-visible");
      }
    };

    const heroSection = document.getElementById("hero-section");
    if (heroSection) {
      window.addEventListener("scroll", handleScroll);
      handleScroll(); // Initial check
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    } else {
      document.body.classList.add("hero-hidden");
      document.body.classList.remove("hero-visible");
    }
  }, []);

  return (
    <Layout>
      <ThemeColorSetter color={themeColor} colorBg={themeColorBg} />
      <main>
        <Header bgColor={projectBgColor} textColor={projectTextColor} />
        {/* On page navigation */}
        <Flex justifyContent="center">
          <Box variant="onPageNav" className="page-nav">
            <UAnchorLink
              to={section1}
              sx={{
                variant: "buttons.outline",
                backgroundColor: "transparent",
              }}
              title="Overview"
            >
              Overview
            </UAnchorLink>
            <UAnchorLink
              to={section2}
              sx={{
                variant: "buttons.outline",
                backgroundColor: "transparent",
              }}
              title="Problem statement"
            >
              Problem
            </UAnchorLink>
            <UAnchorLink
              to={section3}
              sx={{
                variant: "buttons.outline",
                backgroundColor: "transparent",
              }}
              title="Approach"
            >
              Approach
            </UAnchorLink>
            <UAnchorLink
              to={section4}
              sx={{
                variant: "buttons.outline",
                backgroundColor: "transparent",
              }}
              title="Result"
            >
              Result
            </UAnchorLink>
          </Box>
        </Flex>

        {/* Hero / Overview */}
        <div id="section1">
          <Hero
            projectType={"Showcase"}
            title={"Expressive"}
            titleRow={"Brand"}
            titleClassName={"uppercase"}
            productType={"Product Design, Design System"}
            subtitle={
              "A system that conveys design intention, reflecting both brand's personality and it's commitment to accessible, on-brand design."
            }
            projectBg={projectBgColor}
            projectText={projectTextColor}
            year={"2024 — 2026"}
            role={<Fragment>Senior UX Designer</Fragment>}
            company={"ING"}
            roleDesc={
              <Fragment>
                OJv2 is a next-generation design system, designed to unify Web, iOS, and Android under a single scalable foundation.
                Built with <strong>Design Tokens</strong> and native <strong>Figma Variables</strong>, the system introduces a new visual identity, supports multiple customer segments, and enables local teams to extend the system while remaining aligned with global foundations.<br />
                More than a component library, OJv2 is the <strong>architecture that allows thousands of components to behave consistently across products, platforms, themes, and modes</strong>.
              </Fragment>
            }
            disciplines={
              <Fragment>
                Product &mdash; Design &mdash; Development &mdash; Branding
              </Fragment>
            }
            challenge={
              <Fragment>
               ING's design ecosystem had grown into a collection of local design systems, component libraries, themes, and documentation maintained across countries, products, and platforms. <strong>While this enabled local flexibility, it also introduced inconsistencies</strong>, duplication, and increasing maintenance costs.<br />
               At the same time, a new visual identity required a more scalable foundation—one that could support global brand consistency, local needs, accessibility requirements, and future growth.<br />
               <br/>
               The challenge wasn't simply redesigning a component library. It was creating a design system architecture capable of serving thousands of designers, engineers, and and millions of component instances across Web, iOS, and Android.
               <br /><br/>
               <Heading as="h3" variant="catHeading">
                 The Opportunity
               </Heading>
               Instead of treating accessibility, theming, branding, and scalability as separate problems, we saw an opportunity to solve them through a shared architecture.
               The goal was to create a system that could adapt to different contexts without creating more maintenance overhead.

              </Fragment>
            }
            component={
              <BookScene
                coverColor={"#f0c844"}
                textColor={"black"}
                urlTexture={"/models/textures/ing-book-cover-ds.jpg"}
              />
            }
          />
        </div>
        <Box width={[1 / 1]} variant="wrapperVideo" my={[5, 6]}>
          <video autoPlay muted loop playsInline>
            <source src={ExpressiveEngine} type="video/mp4" />
          </video>
        </Box>
        {/* Problem statement */}
        <div id="section2">
          <Flex
            flexWrap="wrap"
            justifyContent="center"
            variant="container"
            id="project-content"
          >
            <Box width={[1 / 1, 1 / 1, 1 / 1]} variant="containerBigTitle">
              <ProjectFadeInTitle
                word1={"The"}
                word2={"System"}
                word3={"Behind"}
                word3ClassName={"outline"}
                word4={"the System"}
                className={"uppercase"}
              />
            </Box>

            <Box variant="containerTxt">
              <Heading as="h3" variant="catHeading">
                Problem statement
              </Heading>
              <Text
                as="p"
                mb={[5, 6]}
                variant="paragraphXL"
                fontWeight="medium"
              >
                ING needed a way to scale design consistency across thousands of components, multiple platforms, customer segments, and local extensions—while introducing a new visual identity and ensuring accessibility by default.
              </Text>
              <Box width={[1 / 1]} mb={[4, 5, 6]} variant="wrapperImg">
                <StaticImage
                  src="../../../img/ing/key-concepts.jpg"
                  alt="Expressive engine"
                />
              </Box> 
              <Heading as="h3" variant="catHeading">
                Challenge #1
              </Heading>
              <Heading as="h3" variant="bigTitleXS">
                One Brand, Many realities
              </Heading>
              <Text as="p" mb={[3, 4]}>
               ING operates across multiple markets, customer segments, and digital products. Local teams had evolved their own design system extensions to solve local specific needs, resulting in fragmented experiences and duplicated effort.
               The challenge was finding the balance between global consistency and local flexibility without forcing every market into the same solution.
              </Text>
              
              <Heading as="h3" variant="catHeading">
                Challenge #2
              </Heading>
              <Heading as="h3" variant="bigTitleXS">
                Complexity at scale
              </Heading>
              <Text as="p" mb={[3, 4]}>
               The design system needed to support:
                <ul>
                  <li>customer segments</li>
                  <li>Light and dark modes</li> 
                  <li>Cross-platform experiences</li> 
                  <li>Accessibility requirements</li> 
                  <li>Future visual identity updates</li> 
                </ul> 
               Every new visual decision multiplied the number of combinations designers and engineers had to maintain. As the system scaled, manual management became increasingly difficult and error-prone.
              </Text>
              <Box width={[1 / 1]} mb={[4, 5, 6]} variant="wrapperImg">
                <StaticImage
                  src="../../../img/ing/complexity.jpg"
                  alt="Colour combinations across themes"
                />
              </Box>              
              <Heading as="h3" variant="catHeading">
                Challenge #3
              </Heading>
              <Heading as="h3" variant="bigTitleXS">
                Color was becoming a maintenance problem
              </Heading>
              <Text as="p" mb={[3, 4]}>
                Color was one of the most complex areas of the system.
                Designers needed ways to create emphasis, support storytelling, and express different brand personalities while remaining accessible and consistent. <br/>
                Yet every new surface, theme, or mode dramatically increased the number of possible color combinations.
                The result was a growing dependency on manual decisions, reviews, and accessibility checks.
              </Text>
              <Box width={[1 / 1]} variant="wrapperImg">
                <StaticImage
                  src="../../../img/ing/accessible-combinations.jpg"
                  alt="Accessible colour combinations"
                />
              </Box>
              <Text as="span" variant="caption" mb={[4, 5, 6]}>
                In practice, a relatively small set of surfaces, themes, modes, and foreground roles already produced more than 1,500 accessible combinations that needed validation.
              </Text>
            </Box>
          </Flex>
        </div>

        <div id="section3">
          {/* Accessible components */}
          <Flex
            flexWrap="wrap"
            py={[3, 4]}
            variant="container"
            justifyContent="center"
            mb={[4, 5]}
          >
            <Box width={[1 / 1, 1 / 1, 1 / 1]} variant="containerBigTitle">
              <ProjectFadeInTitle
                word1={"Accessible"}
                word2={"on"}
                word2ClassName={"outline"}
                word3={"Brand"}
                word3ClassName={"outline"}
                word4={"components"}
                className={"uppercase"}
              />
            </Box>

            <Box variant="containerTxt">
              <Heading as="h3" variant="catHeading">
                Solution
              </Heading>
              <Text as="p" pb={[3, 4]} mb={[5, 6]} variant="paragraphXL">
               We designed and launched OJv2—a unified design system built on design tokens, native Figma Variables, and a scalable architecture shared across Web, iOS, and Android.
               At the core of the system sits the <strong>Expressive Engine</strong>.
              </Text>
              <Box width={[1 / 1]} mb={[4, 5, 6]} variant="wrapperImg">
                <StaticImage
                  src="../../../img/ing/tokens.png"
                  alt="Tokens"
                />
              </Box> 
              <Text as="p" mb={[3, 4]}>
              Rather than treating color as individual design decisions, Expressive transforms color into a system of relationships.<br/>
              <strong>Designers</strong> no longer choose individual foreground and background colors. Instead, they <strong>choose intent</strong>.
              The system automatically generates accessible, on-brand color pairings based on:
              <ul>
                <li>Surface context</li>
              <li>Customer segment themes</li>
              <li>Light and dark modes</li>
              <li>Semantic color roles</li>
              </ul>
              This approach allows components to adapt intelligently to their environment while maintaining accessibility and brand consistency.
              </Text>
              <Box width={[1 / 1]} mb={[4, 5, 6]} variant="wrapperImg">
                <StaticImage
                  src="../../../img/ing/expressive-engine.png"
                  alt="Expressive engine"
                />
              </Box> 
            </Box>
          </Flex>

          <Flex
            flexWrap="wrap"
            py={[3, 4]}
            variant="container"
            justifyContent="center"
            mb={[4, 5]}
          >
            <Box width={[1 / 1, 1 / 1, 1 / 1]} variant="containerBigTitle">
              <ProjectFadeInTitle
                word1={"Expressive"}
                word3={"Engine"}
                word3ClassName={"outline"}
                className={"uppercase"}
              />
            </Box>
            <Box variant="containerTxt">
              <Heading as="h2" variant="bigTitleXS" mb={[3]}>
                A way of working
              </Heading>
              <Text as="p" pb={[3, 4]}>
                Expressive is an extension of the token architecture that brings personality, emphasis, and storytelling into the design system without sacrificing consistency.
                It enables components to automatically respond to:
                <ul>
                  <li>
                    <strong>Surfaces</strong> &mdash; pairing background and foreground tokens
                  </li>
                  <li>
                    <strong>Themes</strong> &mdash; Overall, Business, Private, Wholesale
                  </li>
                  <li>
                    <strong>Modes</strong> &mdash;
                    Light and Dark
                  </li>
                  <li>
                    <strong>Accessibility rules</strong> &mdash;
                    built directly into the combinations
                  </li>
                </ul>
                
                Instead of manually selecting colors and validating contrast ratios, designers can focus on communication and hierarchy while the system handles the complexity behind the scenes.
                The result is a design system that feels expressive and flexible, yet remains predictable, scalable, and accessible by default.

              </Text>
              <Box width={[1 / 1]}>
                <Box variant="wrapperVideo">
                  <video autoPlay muted loop playsInline>
                    <source src={HowToExpressive} type="video/mp4" />
                  </video>
                </Box>
              </Box>

            </Box>
          </Flex>
        </div>

        <div id="section4">
          <Flex
            flexWrap="wrap"
            py={[3, 4]}
            variant="container"
            justifyContent="center"
            mb={[4, 5]}
          >
            <Box variant="containerTxt">
              <Heading as="h2" variant="bigTitleXS">
                Impact
              </Heading>
              <Text as="p">
                <ul>
                <li>Unified component library across Web, iOS, and Android</li>
                <li>Fully tokenized architecture using Design Tokens and Figma Variables</li>
                <li>Built-in support for themes, modes, and future brand evolution</li>
                <li>Design-code parity through shared foundations</li>
                <li>Deprecation of fragmented local design systems</li>
                <li>Single workspace connecting global foundations and local extensions</li>
                <li>Accessible, scalable color combinations powered by the Expressive Engine</li>
                </ul>
              </Text>
              <Heading as="h3" variant="catHeading">
                Adoption looked good on us
              </Heading>
              <Text as="p">OJv2 powers over 24,000 design files, with more than 9 million components used across 32,000 files. Complex corporate setup, with multiple teams across 10 different countries, with more than 2000 active projects using the design system. Enterprise needs vs customer facing UIs.
</Text>
            </Box>
          </Flex>

          {/* <Carousel
            img1={img1}
            img2={img2}
            img3={img3}
            img4={img4}
            img5={img5}
          /> */}
        <Box width={[1 / 1]} variant="wrapperVideo" mt={[5, 6]}>
            <video autoPlay muted loop playsInline>
              <source src={Expressive} type="video/mp4" />
            </video>
          </Box>
          <Flex flexWrap="wrap" justifyContent="center" variant="container">
            {/* Deliverables */}
            <Box variant="containerTxt">
              <Heading as="h3" variant="catHeading">
                The End
              </Heading>
              <Heading as="h2" variant="bigTitleXS">
                Delivered
              </Heading>
              <ul>
                <li>Design System Strategy</li>
                <li>Token Architecture</li>
                <li>Expressive engine</li>
                <li>Documentation Strategy</li>
                <li>Component Governance</li>
                <li>Cross-functional collaboration with Design, Brand and Engineering</li>
              </ul>
              <Heading as="h2" variant="bigTitleXS" mt={[3, 4, 5]}>
                Personal Note
              </Heading>
              <Text as="p">
                In large, global companies, it's crucial to recognize that
                change occurs incrementally and can be challenging to implement.
                Celebrating small victories is essential to maintain momentum
                and encourage ongoing progress.
              </Text>
            </Box>
          </Flex>
        </div>
        <CompanyProjects title="ING" />
        <ProjectTitleListing />
        <BackToTop />
        <Footer />
      </main>
    </Layout>
  );
}

export default ProjectINGDS;
